import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
// import './scss/index.scss';
import LoadingContainer2 from './TokenProduct/LoadingContainer2.js';
import './index.css';
import App from './App';

ReactDOM.render(<LoadingContainer2 />, document.getElementById('root'));
